import React, { useState, useEffect, useCallback } from 'react'
import './styles/styles.scss'
import 'monday-ui-react-core/dist/main.css'
import { Home } from './pages/Home'
import { useGetMondayData } from './hooks/useGetMondayData'
import { useCookies } from 'react-cookie'
import { accountService } from './services/accountService'
import mondaySdk from 'monday-sdk-js'
import { useDarkMode } from './hooks/useDarkMode'
const monday = mondaySdk()

export const App: React.FC = () => {
  const [monayError, setMondayError] = useState<boolean>(false)
  const [accessToken, setAccessToken] = useState<string | undefined>()
  const [cookies, setCookie] = useCookies(['jwt'])
  
  const mondayAccountId: number = useGetMondayData('mondayAccountId', setMondayError)
  const isDarkMode: boolean = useDarkMode(monday)

  const login = useCallback(
    async (mondayAccountId: number) => {
      const accessTokenFromCookie = cookies.jwt
      if (accessTokenFromCookie) {
        console.log('login -> c')
        setAccessToken(accessTokenFromCookie)
      }
      else {
        console.log('login -> a')
        const accessToken: string = await accountService.login(mondayAccountId)
        setCookie('jwt', accessToken)
        setAccessToken(accessToken)
      }
    },
    [cookies, setCookie]
  )

  useEffect(() => {
    mondayAccountId && login(mondayAccountId)
  }, [mondayAccountId, login])

  return (
    <main className={isDarkMode ? 'App darkmode' : 'App'}>
      <Home monday={monday} mondayError={monayError} setMondayError={setMondayError} mondayAccountId={mondayAccountId} accessToken={accessToken!} />
    </main>
  )
}
